import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { renderComponentTree } from '../../dynamicComponentTree';
import AggregateRating from '../../dynamic/AggregateRating';
import AboutSection from '../../dynamic/AboutSection';
import BrandHero from '../../dynamic/BrandHero';
import BrandTopPicks from '../../dynamic/BrandTopPicks';
import Carousel from '../../dynamic/Carousel';
import Collapsible from '../../dynamic/Collapsible';
import Header from '../../dynamic/Header';
import Heading from '../../dynamic/Heading';
import Hero from '../../dynamic/Hero';
import HowDeliverooWorks from '../../dynamic/HowDeliverooWorks';
import ImageWithCaption from '../../dynamic/ImageWithCaption';
import LandingPageFooterContainer from '../../dynamic/LandingPageFooterContainer';
import LocationLink from '../../dynamic/LocationLink';
import LocationList from '../../dynamic/LocationList';
import LocationListFromJSON from '../../dynamic/LocationListFromJSON';
import LocationSearchContainer from '../../dynamic/LocationSearchContainer';
import MenuItem from '../../dynamic/MenuItem';
import PageSection from '../../dynamic/PageSection';
import ResponsiveGridLayout from '../../dynamic/ResponsiveGridLayout';
import RestaurantCardHome from '../../dynamic/RestaurantCardHome';
import RichText from '../../dynamic/RichText';
import RichTextCard from '../../dynamic/RichTextCard';
import RichTextLongCard from '../../dynamic/RichTextLongCard';

function LandingPageContainer({ children }) {
  const components = {
    AboutSection,
    AggregateRating,
    BrandHero,
    BrandTopPicks,
    Carousel,
    Collapsible,
    Header,
    Heading,
    Hero,
    HowDeliverooWorks,
    ImageWithCaption,
    LandingPageFooterContainer,
    LocationLink,
    LocationList,
    LocationListFromJSON,
    LocationSearchContainer,
    MenuItem,
    PageSection,
    ResponsiveGridLayout,
    RestaurantCardHome,
    RichText,
    RichTextCard,
    RichTextLongCard,
  };
  return renderComponentTree(children, components);
}

LandingPageContainer.propTypes = {
  children: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
};
LandingPageContainer.defaultProps = {};

const mapStateToProps = ({ landingPage }) => ({
  children: landingPage.children,
});

export default connect(mapStateToProps)(LandingPageContainer);
